const data = {
  title: "Floor 3-5",
  musicTrack: "MUSIC_WORLD3",
  theme: "PINK",
  tilesWidth: 11,
  tilesHeight: 11,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 6,
      y: 6
    },
    {
      type: "WATER",
      x: 6,
      y: 8
    },
    {
      type: "ICE",
      x: 8,
      y: 3
    },
    {
      type: "ICE",
      x: 5,
      y: 3
    },
    {
      type: "ICE",
      x: 6,
      y: 3
    },
    {
      type: "FIRE",
      x: 7,
      y: 6
    },
    {
      type: "FIRE",
      x: 7,
      y: 7
    },
    {
      type: "WATER",
      x: 8,
      y: 4
    },
    {
      type: "WATER",
      x: 8,
      y: 8
    },
    {
      type: "WATER",
      x: 7,
      y: 8
    },
    {
      type: "ICE",
      x: 7,
      y: 3
    },
    {
      type: "ICE",
      x: 9,
      y: 3
    },
    {
      type: "ICE",
      x: 5,
      y: 9
    },
    {
      type: "ICE",
      x: 7,
      y: 9
    },
    {
      type: "ICE",
      x: 8,
      y: 9
    },
    {
      type: "ICE",
      x: 6,
      y: 9
    },
    {
      type: "ICE",
      x: 9,
      y: 9
    },
    {
      type: "WALL",
      x: 2,
      y: 12
    },
    {
      type: "CHIP",
      x: 8,
      y: 11
    },
    {
      type: "CHIP",
      x: 4,
      y: 11
    },
    {
      type: "CHIP",
      x: 4,
      y: 1
    },
    {
      type: "CHIP",
      x: 8,
      y: 1
    },
    {
      type: "FIRE_BOOTS",
      x: 6,
      y: 8
    },
    {
      type: "WATER_PICKUP",
      x: 6,
      y: 9
    },
    {
      type: "KEY",
      x: 10,
      y: 10,
      color: "GREEN"
    },
    {
      type: "KEY",
      x: 2,
      y: 10,
      color: "BLUE"
    },
    {
      type: "ICE_BOOTS",
      x: 10,
      y: 2
    },
    {
      type: "LOCK",
      x: 6,
      y: 11,
      color: "BLUE"
    },
    {
      type: "LOCK",
      x: 11,
      y: 6,
      color: "GREEN"
    },
    {
      type: "WALL",
      x: 6,
      y: 1
    },
    {
      type: "THIEF",
      x: 3,
      y: 2
    },
    {
      type: "THIEF",
      x: 9,
      y: 10
    },
    {
      type: "THIEF",
      x: 10,
      y: 3
    },
    {
      type: "FIRE",
      x: 6,
      y: 5
    },
    {
      type: "FIRE",
      x: 6,
      y: 7
    },
    {
      type: "FIRE",
      x: 5,
      y: 6
    },
    {
      type: "FIRE",
      x: 5,
      y: 7
    },
    {
      type: "FIRE",
      x: 5,
      y: 5
    },
    {
      type: "WATER",
      x: 6,
      y: 4
    },
    {
      type: "WATER",
      x: 8,
      y: 5
    },
    {
      type: "WATER",
      x: 8,
      y: 6
    },
    {
      type: "WATER",
      x: 8,
      y: 7
    },
    {
      type: "WATER",
      x: 5,
      y: 8
    },
    {
      type: "WATER",
      x: 4,
      y: 8
    },
    {
      type: "WATER",
      x: 4,
      y: 7
    },
    {
      type: "WATER",
      x: 4,
      y: 6
    },
    {
      type: "WATER",
      x: 4,
      y: 5
    },
    {
      type: "WATER",
      x: 4,
      y: 4
    },
    {
      type: "WATER",
      x: 5,
      y: 4
    },
    {
      type: "WATER",
      x: 7,
      y: 4
    },
    {
      type: "FIRE",
      x: 7,
      y: 5
    },
    {
      type: "ICE",
      x: 9,
      y: 4
    },
    {
      type: "ICE",
      x: 9,
      y: 5
    },
    {
      type: "ICE",
      x: 9,
      y: 6
    },
    {
      type: "ICE",
      x: 9,
      y: 7
    },
    {
      type: "ICE",
      x: 9,
      y: 8
    },
    {
      type: "ICE",
      x: 4,
      y: 3
    },
    {
      type: "ICE",
      x: 3,
      y: 3
    },
    {
      type: "ICE",
      x: 3,
      y: 4
    },
    {
      type: "ICE",
      x: 3,
      y: 5
    },
    {
      type: "ICE",
      x: 3,
      y: 7
    },
    {
      type: "ICE",
      x: 3,
      y: 8
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 6,
      isRaised: true
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 6,
      direction: "UP"
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 5,
      direction: "UP"
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 4,
      direction: "UP"
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 3,
      direction: "RIGHT"
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 2,
      direction: "RIGHT"
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 2,
      direction: "RIGHT"
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 2,
      direction: "RIGHT"
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 2,
      direction: "RIGHT"
    },
    {
      type: "CONVEYOR",
      x: 8,
      y: 2,
      direction: "RIGHT"
    },
    {
      type: "CONVEYOR",
      x: 9,
      y: 2,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 4,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 5,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 6,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 7,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 8,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 9,
      direction: "LEFT"
    },
    {
      type: "ICE",
      x: 4,
      y: 9
    },
    {
      type: "ICE",
      x: 3,
      y: 9
    },
    {
      type: "THIEF",
      x: 2,
      y: 9
    },
    {
      type: "CONVEYOR",
      x: 8,
      y: 10,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 10,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 10,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 10,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 10,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 10,
      direction: "UP"
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 8,
      direction: "UP"
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 7,
      direction: "UP"
    },
    {
      type: "CHIP",
      x: 1,
      y: 4
    },
    {
      type: "CHIP",
      x: 1,
      y: 8
    },
    {
      type: "SWITCH",
      x: 3,
      y: 6
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 5,
      direction: "UP",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 11,
      y: 11,
      direction: "UP",
      enemyType: "ENEMY"
    },
    {
      type: "CHIP",
      x: 11,
      y: 4
    }
  ]
};

export default data;
